import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

export const Title = styled(Typography)(({ theme }) => ({
  ["&"]: {
    fontWeight: "bold",
    fontSize: "36px",
    color: theme.palette.neutral.main,
    marginTop: "10px",
    textAlign: "center",
  },
}));

export const Type = styled(Typography)(({ theme }) => ({
  ["&"]: {
    fontWeight: "bold",
    fontSize: "36px",
    color: theme.palette.primary.main,
    marginTop: "10px",
  },
}));

export const Description = styled(Typography)({
  ["&"]: {
    display: "flex",
    gap: "5px",
  },
});

export const Link = styled(Typography)(({ theme }) => ({
  ["&"]: {
    fontWeight: "bold",
    color: theme.palette.neutral.main,
    textDecoration: "underline",
  },
}));
